<template>
  <div class="table">
    <div class="headDiv">
      <a-select class="select" v-if="userInfo().role=='ROLE_SYSTEM'" v-model="searchData.bussdepid">
        <a-select-option value="">--请选择事业部--</a-select-option>
        <a-select-option v-for="item in businssDept" :value="item.id">{{ item.name }}</a-select-option>
      </a-select>
      &nbsp;&nbsp;
      <a-select class="select" v-model="searchData.bussdepType">
        <a-select-option value="">--请选择业务--</a-select-option>
        <a-select-option :value="item.key" v-for="item in bussdepType">{{ item.value }}</a-select-option>
      </a-select>
      &nbsp;&nbsp;
      <a-select class="select" v-model="searchData.bussdepName" v-if="searchData.bussdepType">
        <a-select-option value="">--内容来源--</a-select-option>
        <a-select-option v-for="item in filterChildList" :value="item.name">{{ item.name }}</a-select-option>
      </a-select>
      &nbsp;&nbsp;
      <a-select class="select" v-model="searchData.state">
        <a-select-option value="">--状态--</a-select-option>
        <a-select-option value="1">正常</a-select-option>
        <a-select-option value="2">已移除</a-select-option>
      </a-select>
      &nbsp;&nbsp;
      <a-input placeholder="UID" v-model="searchData.uid"></a-input>
      &nbsp;&nbsp;
      <a-input placeholder="姓名" v-model="searchData.nickName"></a-input>
      &nbsp;&nbsp;
      <a-button type="primary" @click="search">搜索</a-button>
      &nbsp;
      <a-button type="default" @click="reset">重置</a-button>
      &nbsp;
      <a-button type="primary" v-if="userInfo().role!='ROLE_SYSTEM'" @click="addNew">新增</a-button>
    </div>
    <a-table rowKey="id" :loading="loading" :dataSource="userList" :pagination="pagination" @change="handleTableChange">
      <a-table-column
        title="id"
        dataIndex="id"
      />
      <a-table-column
        title="用户uid"
        dataIndex="uid"
      />
      <a-table-column
        title="用户昵称"
        dataIndex="nickName"

      />
      <a-table-column
        title="内容名称"
        dataIndex="auditapp.name"
      />
      <a-table-column
        title="业务来源"
        dataIndex="auditapp.bussdepType"
      ><template slot-scope="scope">
        {{ filterBussdepType(scope) }}
      </template>
      </a-table-column>
      <a-table-column
        title="添加时间"
        dataIndex="createTime"
      />
      <a-table-column
        title="操作人"
        dataIndex="userName"
      />
      <a-table-column
        title="状态"
        dataIndex="state"
      ><template slot-scope="state">
        {{ state==1?'正常':'移除' }}
      </template>
      </a-table-column>
      <a-table-column
        title="备注"
        dataIndex="remarks"
      />
      <a-table-column
        title="操作"
      ><template slot-scope="userid">
        <a-popconfirm v-show="userid.state == 1" title="移除白名单后该用户发言将不再先发后审，是否移除？" @confirm="deleteAccout(userid.id)">
          <a>移除</a>
        </a-popconfirm>&nbsp;
        <a @click="checkHistory(userid.id)">查看历史</a>
      </template>
      </a-table-column>
    </a-table>
    <a-modal
      title="历史记录"
      width="600px"
      @ok="visible=false"
      @cancel="visible=false"
      :visible="visible">
      <a-table rowKey="id" :loading="loading" :dataSource="userList1" :pagination="false">
        <a-table-column
          title="时间"
          dataIndex="createTime"
        />
        <a-table-column
          title="操作人"
          dataIndex="userName"
        />
        <a-table-column
          title="操作"
        ><template slot-scope="item">
          {{ item.userName + (item.operation==1?"添加白名单":"移除白名单") }}
        </template>
        </a-table-column>
      </a-table>
    </a-modal>
    <a-modal
      title="新增"
      width="600px"
      @ok="handleOk1"
      @cancel="visible1=false"
      :visible="visible1">
      <a-form-item
        label="用户UID"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input v-model="newData.uid"></a-input>
      </a-form-item>
      <a-form-item
        label="姓名"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input v-model="newData.nickName"></a-input>
      </a-form-item>
      <a-form-item
        label="业务来源"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-select class="select" v-model="chooseId">
          <a-select-option value="0">--请选择业务--</a-select-option>
          <a-select-option :value="item.key" v-for="item in bussdepType">{{ item.value }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="内容来源"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
        v-show="chooseId!=0"
      >
        <a-select class="select" v-model="newData.auditId">
          <a-select-option value="0">--请选择来源--</a-select-option>
          <a-select-option :value="item.id" v-for="item in originList">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="备注"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-textarea v-model="newData.remarks" rows="5"></a-textarea>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
  // import Config from "../../utils/config";
  // import UserRouteTool from "../../utils/userRouteTool";
  import { mapActions, mapGetters } from 'vuex'
  import { timeFix } from '@/utils/util'
  import { bussdepType,filterBussdepType } from '@/config/public'
import { listhistory, removeItem, queryList ,addItem} from '@/api/whiteList'
import { depList, configmanageList } from '@/api/common'

  var searchData = {
    bussdepType:'',
    bussdepName:'',
    state:'',
    uid:'',
    bussdepid:'',
    nickName:''
  }
  export default {
    name: 'WhiteList',
    components: {},
    data() {
      return {
        searchData:JSON.parse(JSON.stringify(searchData)),
        pagination:{
          pageSize:20,
          total:0,
          showTotal:total => `总共 ${total} 条`,
          current:1
        },
        chooseId:'0',
        newData:{
          uid:'',
          nickName:'',
          auditId:'0',
          remarks:''
        },
        originList:[],
        bussdepType:bussdepType,
        filterBussdepType:filterBussdepType,
        loading:false,
        visible:false,
        visible1:false,
        userList:[],
        userList1:[],
        childList:[],
        businssDept:[],
        filterChildList:[]
      }
    },
    created() {

    },
    mounted() {
      if(window.environment == 'bz'){
        this.bussdepType =  bussdepType.filter(item=>item.value==='投教')
      }
      this.getList()
      this.getAllChildList()
      if (this.userInfo().role=='ROLE_SYSTEM') {
        depList().then(res => {
          if (res.code == 1) {
            if(window.environment == 'bz'){
              this.businssDept = res.result.filter(item=>item.name=='博众事业部')
            }else{
              this.businssDept = res.result
            }
          }
        })
      }
    },
    methods: {
      ...mapGetters(['userInfo']),
      getAllChildList(){
        configmanageList().then(res=>{
          if (res.code==1){
            if(res.result&&res.result instanceof Array){
              this.childList = res.result
            }
          }
        })
      },
      handleOk1(){
        if (!this.newData.uid){
          this.$message.error('uid必填')
          return
        }
        if (!this.newData.nickName){
          this.$message.error('姓名必填')
          return
        }
        if (this.newData.auditId==0){
          this.$message.error('业务来源必')
          return
        }
        addItem(this.newData).then((res) => {
          if (res.code == 1 ) {
            this.visible1 = false
            this.getList()
          }
        })
      },
      addNew(){
        this.newData = {
            uid:'',
            nickName:'',
            auditId:'0',
            remarks:''
        }
        this.visible1 = true
      },
      checkHistory(id){
        this.visible = true
        listhistory({ whiteListId: id }).then((res) => {
        if (res.code == 1 && res.result) {
          this.userList1 = res.result
        }
      })
      },
      reset(){
        this.searchData = JSON.parse(JSON.stringify(searchData))
      },
      deleteAccout(id){
        removeItem({ whiteListId: id }).then((res) => {
          if (res.code == 1) {
            this.$message.success('操作成功')
            this.getList()
          }
        })
      },
      getList(){
        var params = JSON.parse(JSON.stringify(this.searchData))
        params.page = this.pagination.current - 1
        params.size = this.pagination.pageSize
        this.loading = true
        queryList(params)
        .then((res) => {
          if (res.code == 1 && res.result && res.result.content) {
            this.userList = res.result.content
            this.pagination.total = res.result.totalElements
          }
        })
        .finally(() => {
          this.loading = false
        })
      },
      handleOk(){

      },
      search(){
        this.getList(this.searchData)
      },
      handleTableChange (pagination) {
        const pager = { ...this.pagination }
        pager.current = pagination.current
        this.pagination = pager
        this.getList()
      },
    },
    watch:{
      'chooseId':function (value) {
        if (value){
          configmanageList({bussdepType:value}).then(res=>{
            if (res.code==1&&res.result){
              this.originList = res.result
            }
          })
        }
      },
      'searchData.bussdepType':function (val) {
        this.filterChildList = this.childList.filter(item=>item.bussdepType==val)
      }
    }
  }
</script>

<style lang="less" scoped>
  .headDiv{
    padding: 20px;
    /*margin: 10px;*/
    input{
      width: 200px;
    }
  }
  .select{
    width:200px;
  }
  .ant-form-item{
    margin-bottom: 0;
  }
</style>